import React from 'react'
import { ImageField, ImageInput, useTranslate } from 'react-admin'
import KTooltip from 'ui-shared/KTooltip'
import { ImageInputProps } from './SingleImageInput'

const MultiImageInput: React.FC<ImageInputProps> = ({
  accept = '.jpeg, .jpg',
  label = 'form.fields.newImage',
}) => {
  const translate = useTranslate()

  return (
    <KTooltip title="tooltip.hint.imageInput">
      <ImageInput
        source="images"
        maxSize={5000000}
        label={translate(label)}
        accept={accept}
        multiple
      >
        <ImageField
          source="src"
          sx={{ '& .RaImageField-image': { width: '150px' } }}
        />
      </ImageInput>
    </KTooltip>
  )
}

export default MultiImageInput
